import { StakeholderConstraintImpactModel } from './StakeholderConstraintImpactModel';
import { StakeholderStakeImpactModel } from './StakeholderStakeImpactModel';
import { StakeholderRiskImpactModel } from './StakeholderRiskImpactModel';

export type StakeholderModel = {
	id: string;
	name: string;
	description: string;
	x: number;
	y: number;
	trend: string;
	impact: string;
	createdAt: string;
	updatedAt: string;

	impactedRisks: StakeholderRiskImpactModel[];
	impactedStakes: StakeholderStakeImpactModel[];
	impactedConstraints: StakeholderConstraintImpactModel[];

	enabled: boolean;
};

export const defaults = {
	__typename: 'Stakeholder',
	createdAt: new Date(),
	description: '',
	icon: null,
	impact: 'low',
	impactedIndicators: [],
	fishboneLinks: [],
	impactedStakes: [],
	impactedRisks: [],
	links: [],
	name: 'Sample stakeholder',
	scenarios: [],
	taggings: [],
	trend: null,
	x: 0,
	y: 0,
	enabled: true
};
